<template>
  <!-- 商品分组 -->
  <div class="goodsGroup">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商品管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('')"
          >新增分组</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="状态"
          style="width: 100px; margin-right: 10px"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="未启用" value="1"></el-option>
          <el-option label="已启用" value="2"></el-option>
        </el-select>
        <label class="labeljs">检索：</label>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称/厂家"
          @keyup.enter.native="getTableData(1)"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="entName"
        align="center"
        show-overflow-tooltip
        label="机构名称"
      >
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="分组编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="分组名称"
      >
      </el-table-column>
      <el-table-column
        prop="num"
        label="商品数量"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 2">已启用</el-tag>
          <el-tag type="warning" v-if="scope.row.status == 1">未启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 2">
            <el-button type="text" @click="changeStatus(scope.row, 1)"
              >禁用</el-button
            >
            <el-button type="text" @click="handleManGoods(scope)"
              >商品维护</el-button
            >
          </div>
          <div v-if="scope.row.status == 1">
            <el-button type="text" @click="changeStatus(scope.row, 2)"
              >启用</el-button
            >
            <el-button type="text" @click="handleEdit(scope)">编辑</el-button>
            <el-button type="text" @click="handleManGoods(scope)"
              >商品维护</el-button
            >
            <!-- <el-button type="text" @click="changeStatus(scope.row, 0)"
              >删除</el-button
            > -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 商品分类 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">商品分组</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="分组名称" prop="name">
              <el-input
                v-model="addForm.name"
                clearable
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "goodsGroup",
  data() {
    return {
      /**表格数据 */
      // {
      //   id: "分组编号",
      //   entId:"机构编号",
      //   entName:"机构名称",
      //   name:"分组名称",
      //   type:"分组类型",
      //   num:"商品数量",
      //   time:"创建日期",
      //   status:"状态",
      // }
      tableData: [],
      searchForm: {
        status: "99",
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],

      /**新增drawer */
      addDrawer: false,
      /**新增分组表单 */
      addForm: {
        id: "", // 分组ID
        name: "", // 分组名称
      },
      addFormRule: {
        name: [mustFill],
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GetPromGoodsGroup",
        status: this.searchForm.status,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_PromGoodsGroup"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "prom/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = res.recordCount;
          if (res.flag == 0) {
            this.tableData = res.data.map((item) => ({
              id: item.GroupId,
              entId: item.entname,
              entName: item.entname,
              name: item.GroupName,
              type: item.Genre,
              sort: item.sort || 1,
              num: item.GoodsCount,
              time: item.addTime,
              status: item.Status,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        // this.$confirm("确定删除吗?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "error",
        // })
        //   .then(() => {
        row = this.selectedList[0];
        this.changeStatus(row, 0);
        //     })
        //     .catch(() => {});
        // } else {
        //   this.$message({
        //     message: "只能删除一条数据",
        //     type: "warning",
        //   });
      }
    },
    /**点击更改状态 */
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 1) {
        msg = "确定禁用吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定启用吗?";
        type = "success";
      } else if (status == 0) {
        msg = "确定删除吗?";
        type = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "UpdatePromGoodsGroupStatus",
            GroupId: row.id,
            status: status,
          };
          let proc = "Proc_PromGoodsGroup"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "prom/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },

    /**新增/编辑分类 row, isEdit*/
    handleAdd() {
      this.addDrawer = true;
    },

    /**点击商品维护 */
    handleManGoods({ row }) {
      let prams = "";
      if (row) {
        prams = encodeURIComponent(
          JSON.stringify({
            id: row.id,
            name: row.name,
            type: row.type,
            sort: row.sort,
            isEdit: true,
          })
        );
      }
      this.$router.push({
        path: "addGoodsGroup",
        query: {
          prams: prams,
        },
      });
    },

    /**点击编辑 */
    handleEdit({ row }) {
      this.addDrawer = true;
      this.addForm.name = row.name;
      this.addForm.id = row.id;
    },

    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (const key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addDrawer = false;
    },

    /** 新增、编辑提交新增分组 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            groupName: this.addForm.name,
            groupId: this.addForm.id,
          };

          this.$request({
            method: "post",
            url: "/Management/GoodsAdmin/SaveGoodsGroupMt",
            data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              }
              this.clearForm();
              this.getTableData();
              this.addDrawer = false;
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.goodsGroup {
  width: 100%;
  height: 100%;
}
</style>
